import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const EscalationsToDevelopmentTeams = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://www.atlassian.com${useLocalizedHref(
        "/software/jira/service-management/product-guide/tips-and-tricks/customer-service-management"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.EscalationsToDevelopmentTeams.header",
            defaultMessage: "Escalations to development teams"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.EscalationsToDevelopmentTeams.body",
            defaultMessage:
                "Escalate support requests to development teams directly from the issue. Include additional context on what is needed, when, and why in an accompanying escalation message."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.EscalationsToDevelopmentTeams.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about service management for customer support teams."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default EscalationsToDevelopmentTeams;
